
<template>
    <div>
        <Form inline>
            <FormItem :label="$t('global.common.project',{defaultValue:'项目'})" :label-width="60">
                
                <div>
                    <Select clearable v-model="formData.lineId" filterable >
                        <Option v-for="item in getNewProductList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                </div>
            </FormItem>
            <FormItem :label="$t('erp.virtualstore.actualoutwarehouse',{defaultValue:'实际出库仓库'})" :label-width="90">
                <div>
                    <Select clearable v-model="formData.orgWarehouseId" filterable >
                        <Option v-for="item in warehouses" :value="item.id" :key="item.id">{{ item.title }}({{ item.code }})</Option>
                    </Select>
                </div>
            </FormItem>
            <FormItem label='ERP SKU' :label-width="70">
                <Select style="width:180px;" clearable filterable v-model="formData.erpSku" ref="zierpselect" remote :remote-method="remoteMethod1" :loading="loading1">
                    <Option v-for="item in erpSkusList" :value="item.name" :key="item.id">{{ item.name }}</Option>
                </Select>
            </FormItem>
            
            <FormItem :label-width="1">
                <Button type="primary" @click="getVsGroupRule" icon="ios-search">{{$t('global.common.search',{defaultValue:'搜索'})}}</Button>
                <Button @click="reset" icon='md-refresh'>{{$t('erp.disturibution.reset_order',{defaultValue:'重置'})}}</Button>
            </FormItem>
        </Form>
        <Table
        :columns="columns" 
		:data="data"
        stripe
        border
        :loading="loading"
        ></Table>
        <compSpage
		class="text-right margin-top-10"
		v-bind="{total,pageSize:formData.rows,current:formData.page}" 
		@on-update="updateList"></compSpage>
    </div>
</template>
<script>
import { mapState,mapGetters } from 'vuex';
import compSpage from '@/components/boss/spage';
import {
    HttpVsAllot,
    HttpUpdateVsAllot,
    HttpVsAllotNo,
    HttpVsRuleList,
    HttpVsQuantity,
    HttpGroupRuleAlert,
    HttpProductByLineId,
    HttpVsSkuList,
} from '@/service/boss/allot';
export default {
    props:['virtlineId','virtorgWarehouseId','virterpSku','virtalertsearch'],
    components: {
		compSpage
	},
    data() {
        return {
            formData: {
                page: 1,
                rows: 10,
                lineId:'',
                orgWarehouseId:'',
                erpSku:'',
            },
            erpSkusList:[],
            title: "",
            rowId: "",
            data:[],
            total: 0,
            loading: false,
            loading1:false,
        };
    }, 
    computed: {
        // ...mapState('boss',['products']),
        ...mapGetters('boss',['warehouses']),
        ...mapGetters('diction',['getNewProductList']),
        columns() {
            return [
                {
                    width: 90,
                    render: (h, { row, index }) => {
                        return h('Radio', {
                            props: {
                                value: this.rowId === index
                            },
                            on: {
                                input: (event) => {
                                    this.rowId = index;
                                }
                            }
                        })
                    }
                },
                {
                    title: this.$t('global.common.project',{defaultValue:'项目'}),
                    key: 'lineId',
                    render: (h, { row }) => {
                        const id = row.lineId;
                        const product = this.getNewProductList.filter((item) => {
                            return id == item.value
                        })[0] || {};
                        return <span>{product.label}</span>
                    },
                }, 
                {
                    title: this.$t('erp.virtualstore.actualoutwarehouse',{defaultValue:'实际出库仓库'}),
                    key: 'warehouseTitle',
                },
                {
                    title: 'ERP SKU',
                    key: 'erpSku',
                },
                {
                    title: this.$t('erp.virtualstore.virtualoutware',{defaultValue:'虚拟出库仓'}),
                    key: 'ruleName',
                }, 
            ];
        },
    },
    watch:{
        virtalertsearch:function(){
            if(this.virtalertsearch == true){
                this.getProductList(this.virtlineId)
                this.getVsGroupRule();
            }
        },
    },
    methods: {
        getRowData() {
            return this.data[this.rowId] || {}
        },
        reset() {
                this.formData = {
                    page: 1,
                    rows: 10,
                    lineId:'',
                    orgWarehouseId:'',
                    erpSku:'',
                };
            this.getVsGroupRule();
        },
        remoteMethod1(query){
            // console.log(query)
            HttpVsSkuList({page: 1,rows: 100,'search[CN_erpSku]':query}).then(res => {
                // console.log(res)
                this.erpSkusList = res.data.content.map((item) => {
                    return { name: item.erpSku, id: item.id }
                });
            });
        },
        async getProductList() {
            this.$refs.zierpselect.clearSingleSelect();
            this.formData.erpSku = ''
            HttpVsSkuList({page: 1,rows: 10}).then(res => {
                // console.log(res)
                this.erpSkusList = res.data.content.map((item) => {
                    return { name: item.erpSku, id: item.id }
                });
            });
        },
        async getVsGroupRule() {
            this.loading = true;
            let lined,warehouse,erpSku;
            if(this.virtalertsearch == true){
                // console.log(2222222)
                    lined = this.formData.lineId
                    warehouse = this.formData.orgWarehouseId
                    erpSku = this.formData.erpSku
            }
            else{
                // console.log(14444)
                lined = this.formData.lineId = '';
                warehouse = this.formData.orgWarehouseId = ''
                erpSku = ''
            }
            const response = await HttpGroupRuleAlert({
                page: 1,
                rows: 10,
                lineId:lined,
                orgWarehouseId:warehouse,
                erpSku:erpSku,
            });
            if (response) {
                this.loading = false;
                this['inVsrule'] = this["outVsrule"] = response.data.content;
                this.data = response.data.content
                this.total = response.data.totalElements || 0;
            }
        },
        async updateList(data) {
			this.loading = true;
            this.formData = Object.assign({}, this.formData, data);
			const response = await HttpGroupRuleAlert(this.formData).catch(res => {
				this.loading = false;
				this.$Message.error(res.message);
			});
			if (response) {
				const data = response.data;
				this.loading = false;
				this.data = data.content || [];
				this.total = data.totalElements || 0;
			}
		},
    },
    
};
</script>
